(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["px-lockscreen"] && !Shopify.designMode) return;
  try {
    
window.PXNet = window.PXNet || function (svg) {
  var NS = "http://www.w3.org/2000/svg";
  if (svg.dataset.pxInit) return;
  svg.dataset.pxInit = "1";
  var W = +svg.dataset.w || 1280, H = +svg.dataset.h || 760;
  var color = svg.dataset.color || "#6aa8ff", accent = svg.dataset.accent || "#ff4d5e";
  var n = +svg.dataset.nodes || 60;
  function rnd(a, b) { return a + Math.random() * (b - a); }
  function el(t, a) { var e = document.createElementNS(NS, t); for (var k in a) e.setAttribute(k, a[k]); return e; }

  var nodes = [], i;
  for (i = 0; i < n; i++) nodes.push({ x: rnd(-40, W + 40), y: rnd(-40, H + 40) });

  // edges: connect each node to its nearest few neighbours (deduped)
  var edges = {};
  nodes.forEach(function (a, ia) {
    var others = nodes.map(function (b, ib) { return { ib: ib, d: (a.x - b.x) * (a.x - b.x) + (a.y - b.y) * (a.y - b.y) }; })
      .filter(function (o) { return o.ib !== ia; })
      .sort(function (p, q) { return p.d - q.d; }).slice(0, 3);
    others.forEach(function (o) {
      var key = ia < o.ib ? ia + "_" + o.ib : o.ib + "_" + ia;
      edges[key] = true;
    });
  });

  Object.keys(edges).forEach(function (key) {
    var p = key.split("_"), a = nodes[+p[0]], b = nodes[+p[1]];
    var red = Math.random() < 0.16, c = red ? accent : color;
    svg.appendChild(el("line", { x1: a.x, y1: a.y, x2: b.x, y2: b.y, stroke: c, "stroke-opacity": red ? "0.26" : "0.16", "stroke-width": "0.8" }));
    if (Math.random() < 0.5) {
      var pulse = el("line", { x1: a.x, y1: a.y, x2: b.x, y2: b.y, stroke: c, "stroke-width": "1.5", "stroke-linecap": "round", pathLength: "100", "stroke-dasharray": "4 96", class: "gpulse" });
      pulse.style.animationDuration = rnd(3, 7).toFixed(2) + "s";
      pulse.style.animationDelay = rnd(0, 6).toFixed(2) + "s";
      svg.appendChild(pulse);
    }
  });

  nodes.forEach(function (a) {
    var d = el("circle", { cx: a.x, cy: a.y, r: rnd(0.8, 2).toFixed(2), fill: Math.random() < 0.16 ? accent : color, class: "gdot" });
    d.style.animationDuration = rnd(2, 5).toFixed(2) + "s";
    d.style.animationDelay = rnd(0, 4).toFixed(2) + "s";
    svg.appendChild(d);
  });
};

window.PXCountdown = window.PXCountdown || function (root) {
  function pad(x) { return (x < 10 ? "0" : "") + x; }
  (root || document).querySelectorAll("[data-px-countdown]").forEach(function (box) {
    if (box.dataset.pxOn) return; box.dataset.pxOn = "1";
    var target = Date.parse((box.dataset.target || "").replace(" ", "T"));
    if (isNaN(target)) { box.style.display = "none"; return; }
    var eD = box.querySelector("[data-d]"), eH = box.querySelector("[data-h]"), eM = box.querySelector("[data-m]"), eS = box.querySelector("[data-s]");
    function tick() {
      var t = Math.max(0, target - Date.now());
      eD.textContent = pad(Math.floor(t / 86400000)); eH.textContent = pad(Math.floor(t / 3600000) % 24);
      eM.textContent = pad(Math.floor(t / 60000) % 60); eS.textContent = pad(Math.floor(t / 1000) % 60);
    }
    tick(); setInterval(tick, 1000);
  });
};

(function () {
  function initAll(root) {
    (root || document).querySelectorAll(".px-net[data-px-net]").forEach(function (s) { window.PXNet(s); });
    window.PXCountdown(root);
  }
  if (document.readyState !== "loading") initAll(); else document.addEventListener("DOMContentLoaded", function () { initAll(); });
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
